import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import {
  type AccountSettings,
  accountSettings,
} from "../schemas/accountSettings";

export const getAccountSettingsProps = z
  .object({ token: z.string() })
  .extend(requestConfig.shape);

export type GetAccountSettingsProps = z.infer<typeof getAccountSettingsProps>;

export const getAccountSettings = async (
  args: GetAccountSettingsProps,
): Promise<AccountSettings> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    proxyAuthSecret,
  } = parseServiceInput(getAccountSettingsProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v1/account/settings`, {
    method: "GET",
    headers,
  });

  return parseServiceOutput(response, accountSettings, {
    code: "MALFORMED_ACCOUNT",
    message: "Account is malformed",
  });
};
